export default "__VITE_ASSET__BqGO4O3Z__"